import { generateKeyPair } from '@libp2p/crypto/keys';
import { keychain } from '@libp2p/keychain';
import { defaultLogger } from '@libp2p/logger';
import { Key } from 'interface-datastore';
export async function loadOrCreateSelfKey(datastore, init = {}) {
    const selfKey = init.selfKey ?? 'self';
    const chain = keychain(init)({
        datastore,
        logger: defaultLogger()
    });
    let privateKey;
    if (await datastore.has(new Key(`/pkcs8/${selfKey}`))) {
        privateKey = await chain.exportKey(selfKey);
    }
    else {
        privateKey = await generateKeyPair(init.keyType ?? 'Ed25519');
        // persist the peer id in the keychain for next time
        await chain.importKey(selfKey, privateKey);
    }
    return privateKey;
}
//# sourceMappingURL=load-private-key.js.map